export default "__VITE_ASSET__BnujT6vr__"